<template>
  <el-dialog
    title="分享"
    :visible.sync="visible"
    width="427px"
    :before-close="close"
    class="share-dialog"
    ref="shareDialog"
  >
    <ShareViewGuide :imgURL="shareImg" :showModelVisible="showModelVisible" @closeModel="closeModel" />
    <div id="_detail_share_container_" v-if="detail">
      <div class="header" v-if="active === 1">
        <img class="logo" src="@/assets/images/share-logo.png" alt="" />
        <!--        <span class="desc">全球精品游戏wiki攻略站</span>-->
      </div>
      <div class="main">
        <!-- 文章标题 -->
        <detail-title :detail="detail"></detail-title>
        <!-- 文章描述 -->
        <!--<detail-desc :detail="detail"></detail-desc>-->
        <!-- 贡献者 -->
        <!-- <detail-contributor :detail="detail"></detail-contributor>-->
        <!-- 老编辑器 -->
        <detail-content v-if="detail.editor_type == 0" :content-data="detail" />
        <!-- 新编辑器 -->
        <detail-json-content v-if="detail.editor_type == 1" :content-data="detail" />
        <!-- 图鉴编辑器 -->
        <book-content
          v-else-if="detail.editor_type == 2"
          mode="view"
          :content-data="formatContentData(detail.content_json)"
        />
      </div>
      <div class="footer" :class="{ footerMaskLayer: active === 0 }" id="_footer_">
        <div class="left">
          <div class="game">
            <img class="icon" :src="detail.game.icon" />
            <span class="name">{{ detail.game.name }}</span>
          </div>
          <div class="share-title">{{ detail.title }}</div>
          <div class="avatar-info">
            <img class="avatar" :src="detail.user.avatar" alt="" />
            <div class="info">
              <div class="username">
                {{
                  detail.user.username && detail.user.username.length > 4
                    ? detail.user.username.slice(0, 4) + "..."
                    : detail.user.username
                }}
              </div>
              <div class="update">{{ dayjs(detail.updated_at * 1000).format("YYYY/MM/DD") }}更新</div>
              <div class="read">{{ formatCount(detail.view_count) }}阅读量</div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="qrcode-box">
            <div class="qrcode">
              <qrcode-vue :correctLevel="3" :margin="0" :size="134" :value="shareUrl" colorDark="#404040" />
              <img class="logo" src="@/assets/images/favicon.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box">
      <div class="tab-box">
        <div class="tab">
          <div class="tab-item" :class="{ active: active === 0 }" @click="handleTabChange(0)">海报</div>
          <div class="tab-item" :class="{ active: active === 1 }" @click="handleTabChange(1)">整页截图</div>
        </div>
      </div>
      <div class="container-box" ref="containerBox">
        <div class="share-img" v-if="loaded">
          <img class="share-canvas" style="height: 100%;" ref="shareImg" :src="shareImg" alt="" />
          <div v-show="false" class="footer-img" ref="footerImg">
            <img :src="footerImg" alt="" />
          </div>
        </div>
        <div class="empty" v-else>
          <div class="loading_wrapper">
            <div class="loader"></div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="bottom">
      <button class="btn" @click="saveImg(shareImg, detail.title)">保存图片</button>
      <button class="btn" @click="linkShare">复制链接分享</button>
    </div>
    <MediaShareFooter v-if="loginUser.is_super"/>
  </el-dialog>
</template>

<script>
import dayjs from "dayjs";
import DetailTitle from "./detailTitle";
import DetailDesc from "./detailDesc.vue";
import DetailContributor from "./detailContributor";
import DetailContent from "./detailContent";
import DetailJsonContent from "./detailJsonContent";
import ShareViewGuide from "./shareViewGuide.vue";
import BookContent from "@/views/editor/wiki-editor/illustrated-book/BookContent";
import html2canvas from "html2canvas-pro";
import imagesloaded from "imagesloaded";
import QrcodeVue from "qrcode.vue";
import Clipboard from "clipboard";
import { toast } from "@/plugins/util";
import MediaShareFooter from './mediaShareFooter.vue'
// store
import { mapGetters } from "vuex";

export default {
  components: {
    DetailTitle,
    DetailDesc,
    DetailContributor,
    DetailContent,
    DetailJsonContent,
    BookContent,
    QrcodeVue,
    ShareViewGuide,
    MediaShareFooter
  },
  data() {
    return {
      detail: null,
      visible: false,
      loaded: false,
      shareImg: "",
      footerImg: "",
      shareUrl: "",
      active: 0,
      isInit: true,
      scrollPosition: 0, // 当前滚动位置
      showModelVisible: false
    };
  },
  computed: {
    ...mapGetters(["gameInfo", "loginUser"])
  },
  created() {
    this.waterMarkText = this.gameInfo.name + "-Kwiki";
  },
  methods: {
    dayjs,
    handleTabChange(active) {
      this.active = active;
      this.loaded = false;
      this.$nextTick(() => {
        this.toImg();
      });
    },
    open(detail) {
      console.log(detail);
      this.visible = true;
      this.loaded = false;
      this.shareUrl = window.location.href;
      this.detail = detail;
      setTimeout(() => {
        const container = document.getElementById("_detail_share_container_");
        // 图片加载
        const imgs = container.querySelectorAll("img");
        imgs.forEach(img => {
          img.classList.remove("lazy-img");
          const dataSrc = img.getAttribute("data-src") || img.getAttribute("data-real");
          if (dataSrc) {
            img.src = dataSrc;
          }
          img.setAttribute("loading", "eager");
          img.setAttribute("lazy", "loaded");
          img.setAttribute("crossOrigin", "anonymous");
        });
        // 视频替换为封面
        const videos = container.querySelectorAll("video");
        videos.forEach(video => {
          const posterHtml = `
          <div style="position: relative;width: 100%;min-height:200px">
            <img src="${video.poster}" alt="" style="width: 100%;" />
            <i class="wiki-icon wiki-icon-video-play" style="display: inline-block;width: 57px;height: 57px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"></i>
          </div>
          `;
          video.parentNode.innerHTML = posterHtml;
        });
        // iframe
        const iframes = container.querySelectorAll("iframe");
        iframes.forEach(iframe => {
          const tempHtml = `
          <div style="position: relative;width: 100%;min-height:200px;display:flex;align-items: center;justify-content: center; background: #f5f5f5;">
            <span>嵌入内容</span>
          </div>
          `;
          iframe.parentNode.innerHTML = tempHtml;
        });
        this.toImg();
      });
    },
    close() {
      this.visible = false;
      this.active = 0;
    },
    async toImg() {
      const html2canvasConfig = {
        useCORS: true,
        scale: 1,
        scrollX: 0,
        scrollY: 0
      };
      try {
        const container = document.getElementById("_detail_share_container_");
        const footer = document.getElementById("_footer_");

        await new Promise(resolve => {
          imagesloaded("#_detail_share_container_", resolve);
        });

        const [mainCanvas, footerCanvas] = await Promise.all([
          html2canvas(container, {
            ...html2canvasConfig,
            ignoreElements: el => this.active === 0 && el.classList.contains("footer")
          }),
          this.active === 0 &&
            html2canvas(footer, {
              ...html2canvasConfig,
              width: 878
            })
        ]);
        // 处理主内容
        if (mainCanvas) {
          this.handleCanvasResult(mainCanvas, "shareImg");
        }

        // 处理 footer
        if (this.active === 0 && footerCanvas) {
          this.handleCanvasResult(footerCanvas, "footerImg");
        }

        this.loaded = true;
        this.showModelVisible = !localStorage.getItem("isFirstShare");
        if (this.isInit) {
          this.isInit = false;
        }
      } catch (error) {
        console.error("生成图片失败:", error);
        this.loaded = true;
      }
    },
    handleCanvasResult(canvas, targetProp) {
      this[targetProp] = canvas.toDataURL("image/png");
    },
    async saveImg(url, name = "gamekee-share-img") {
      if (this.active !== 0) {
        return this.downloadImg(url, name);
      }

      try {
        // 常量提取
        const RATIO = 2.25;
        const WIDTH = 878;
        const FOOTER_HEIGHT = 182;

        // DOM 元素缓存
        const container = this.$refs.containerBox;
        const footer = this.$refs.footerImg;
        const shareImg = this.$refs.shareImg;

        console.log("shareImg.clientHeight", shareImg.clientHeight);
        // 尺寸计算
        const compareHeight =
          shareImg.clientHeight > container.clientHeight ? container.clientHeight : shareImg.clientHeight;
        const containerHeight = compareHeight * RATIO;
        const totalHeight = containerHeight + FOOTER_HEIGHT;

        // 创建临时容器
        const tempContainer = this.createTempContainer({
          width: WIDTH,
          height: totalHeight,
          className: "temp-container"
        });

        // 克隆并处理内容
        const contentClone = this.cloneAndStyleNode(container, {
          position: "relative",
          // height: container.scrollHeight * RATIO + 'px',
          transform: `translateY(-${container.scrollTop * RATIO}px)`,
          width: WIDTH + "px",
          margin: 0,
          boxSizing: "border-box"
        });

        // 克隆并处理页脚
        const footerClone = this.cloneAndStyleNode(footer, {
          position: "absolute",
          bottom: "-5px",
          left: "0",
          width: "100%",
          borderRadius: "0 0 16px 16px",
          display: "block"
        });

        // 创建顶部蒙层
        const topBlurred = this.createStyledElement(
          "div",
          {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "50px",
            background: "linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)"
          },
          ["top-blurred"]
        );

        // 组装元素
        tempContainer.append(contentClone, topBlurred, footerClone);
        document.body.appendChild(tempContainer);

        // 生成截图
        const canvas = await html2canvas(tempContainer, this.getCanvasConfig(WIDTH, totalHeight));
        const urlLink = canvas.toDataURL("image/png");
        this.downloadImg(urlLink, name);
      } catch (error) {
        console.error("截图失败:", error);
        this.$notify.error("生成截图失败，请重试");
      } finally {
        this.cleanupTempContainer();
      }
    },
    // 创建带样式的元素
    createStyledElement(tagName, styles = {}, classList = []) {
      const el = document.createElement(tagName);
      Object.assign(el.style, styles);
      el.classList.add(...classList);
      return el;
    },

    // 克隆并处理节点
    cloneAndStyleNode(node, styles) {
      const clone = node.cloneNode(true);
      Object.assign(clone.style, styles);
      return clone;
    },

    // 创建临时容器
    createTempContainer({ width, height, className }) {
      return this.createStyledElement(
        "div",
        {
          position: "absolute",
          top: "-2000px",
          left: "-2000px",
          height: height + "px",
          width: width + "px",
          borderRadius: "16px",
          overflow: "hidden"
        },
        [className]
      );
    },
    // 清理临时容器
    cleanupTempContainer() {
      const containers = document.querySelectorAll(".temp-container");
      containers.forEach(container => container.remove());
    },
    // 获取 canvas 配置
    getCanvasConfig(width, height) {
      return {
        scale: window.devicePixelRatio || 1,
        useCORS: true,
        width: width,
        height: height,
        backgroundColor: null,
        logging: process.env.NODE_ENV === "development"
      };
    },
    downloadImg(url, name) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `${name}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    linkShare() {
      let shareText = `${this.detail.user.username}分享了文章:${this.detail.title}\r\n`;
      shareText += window.location.href + "\r\n";
      shareText += "来自GameKee";
      let $div = document.createElement("div");
      $div.setAttribute("data-clipboard-text", shareText);
      $div.classList.add("page-share-copy-btn");
      document.body.appendChild($div);
      let clipboard = new Clipboard(".page-share-copy-btn");
      clipboard.on("success", e => {
        toast("复制成功！");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        toast("浏览器不支持自动复制,请更换其他浏览器");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      $div.click();
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    },
    closeModel() {
      this.showModelVisible = false;
      localStorage.setItem("isFirstShare", "true");
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  border-radius: 12px;
}

/deep/ .el-dialog__header {
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  background: #f1f5fd;
  border-radius: 12px 12px 0 0;
}

/deep/ .el-dialog__body {
  position: relative;
  padding: 0;
  background: #f1f5fd;
}

/deep/ .el-dialog__footer {
  padding: 0;
  background: #f1f5fd;
  border-radius: 0 0 12px 12px;

  .bottom {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;

    .btn {
      width: 189px;
      height: 40px;
      background: #dbe2f0;
      border-radius: 20px;
      border: none;
    }
  }
}

.content-box {
  .tab-box {
    background: #f1f5fd;
    width: 100%;
    padding: 10px 16px;

    .tab {
      width: 388px;
      height: 42px;
      background: #dde5f4;
      border-radius: 21px;
      display: flex;
      align-items: center;
      padding: 0 4px;
      gap: 4px;

      .tab-item {
        width: 190px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #72818b;
        cursor: pointer;
        border-radius: 17px;

        &.active {
          background: #fff;
          border-radius: 17px;
          font-weight: 600;
          font-size: 14px;
          color: #51616f;
        }
      }
    }
  }

  .container-box {
    width: 100%;
    height: 395px;
    background: #f1f5fd;
    padding: 0 16px;
    overflow-y: scroll;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.15);
    // border: none;
    // border-radius: 20px;
    /* 滚动槽 */

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 3px;
      background: rgba(0, 0, 0, 0.06);
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.08);
    }

    /* 滚动条滑块 */

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: rgba(0, 0, 0, 0.12);
      -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    }

    .share-img {
      width: 100%;
      height: auto;
      box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.15);
      font-size: 0;

      img {
        width: 100%;
      }

      .footer-img {
        height: 187px;
      }
    }
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 18px;
    height: 395px;
    overflow: hidden;
    background: #fff;

    .icon {
      width: 97px;
      height: 97px;
    }

    .desc {
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
    }

    .loading_wrapper {
      width: 96px; /* loader宽度的2倍 */
      height: 96px; /* loader高度的2倍 */
      background: rgba(0, 0, 0, 0.5); /* 黑色半透明 */
      border-radius: 16px; /* 圆角效果 */
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .loader {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: inline-block;
      position: relative;
      border: 3px solid;
      border-color: transparent #0babfd #0babfd;
      animation: rotation 2s linear infinite;
      margin: 20px;
    }

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}

.model_wrap {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
}

#_detail_share_container_ {
  background-color: #fff;
  width: 878px;
  position: fixed;
  left: -1000px;
  //left: 0;
  top: 0;
  z-index: 1000;
  //padding-bottom: 185px;
  border-bottom: 1px solid #f1f5fb;

  .header {
    width: 100%;
    height: 110px;
    background: #ffffff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 34px 40px;

    .logo {
      width: 300px;
      height: 45px;
      margin-right: 36px;
      vertical-align: bottom;
    }

    .desc {
      font-weight: 500;
      font-size: 32px;
      color: #757575;
      line-height: 45px;
    }
  }

  .main {
    padding: 20px 20px 0 20px;
    border-radius: 30px;
  }

  .footerMaskLayer::before {
    position: absolute;
    top: -190px;
    left: 0;
    content: "";
    display: block;
    width: 100%;
    height: 200px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
  }

  .footer {
    //position: absolute;
    //bottom: 0;
    //left: 0;
    z-index: 1000;
    width: 100%;
    height: 182px;
    padding: 18px 27px 18px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;

    .left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 80%;
      .game {
        display: flex;
        align-items: center;
        column-gap: 4px;
        padding: 4px;
        background-color: #edeff5;
        box-sizing: content-box;
        width: fit-content;
        border-radius: 4px;
        .icon {
          width: 24px;
          height: 24px;
        }
        .name {
          color: #333;
          font-size: 14px;
        }
      }
      .share-title {
        color: #333;
        font-size: 28px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .avatar-info {
        display: flex;
        align-items: center;
        width: 100%;

        .avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 15px;
        }

        .info {
          display: flex;
          width: 80%;

          .username,
          .update,
          .read {
            font-weight: 400;
            font-size: 22px;
            color: #888888;
            line-height: 41px;
            margin-right: 15px;
          }
        }
      }
    }

    .right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 18px;

      .info {
        width: 300px;
        display: flex;
        flex-direction: column;

        .arrow {
          text-align: right;
          margin-bottom: 23px;

          img {
            width: 62px;
            height: 36px;
          }
        }

        .tips {
          width: 100%;
          text-align: right;
          font-weight: 400;
          font-size: 25px;
          color: #999999;
          line-height: 36px;
          margin-bottom: 3px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .qrcode-box {
        width: 146px;
        height: 146px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;
        border: 1px solid #404040;
      }

      .qrcode {
        position: relative;
        width: 146px;
        height: 146px;
        padding: 4px;

        .logo {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 32px;
          height: 32px;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}
</style>
<style>
.temp-container {
  border-radius: 16px;
  overflow: hidden;
  background: #fff;

  .share-img {
    height: 100% !important;

    .share-canvas {
      height: 100% !important;
      width: 100% !important;
    }
  }

  .top-blurred {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 25px;
    background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  }

  .footer-img {
    width: 100%;
    border-radius: 0 0 16px 16px;

    img {
      width: 100%;
    }
  }

  .footer-img::before {
    position: absolute;
    top: -24px;
    left: 0;
    content: "";
    display: block;
    width: 100%;
    height: 25px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
  }
}

.temp-container::-webkit-scrollbar {
  display: none;
}
</style>
